module.exports = __webpack_public_path__ + "img/ico-recipient-off-copy.73ece7a1.svg";